import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Como funciona", id: "como-funciona" },
  { label: "Categorias", id: "categorias" },
  { label: "Bônus", id: "bonus" },
  { label: "FAQ", id: "faq" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="safe-top fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-slate-950/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Logo />

        <nav className="hidden items-center gap-7 md:flex">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => goToSection(item.id)}
              data-testid={`nav-${item.id}`}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-white"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/ferramenta" className="hidden sm:block no-underline">
            <Button
              variant="ghost"
              data-testid="header-tool-link"
              className="rounded-full text-slate-200 hover:bg-white/5 hover:text-white"
            >
              Testar ferramenta
            </Button>
          </Link>
          <button
            className="md:hidden text-slate-200"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/5 bg-slate-950/95 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => goToSection(item.id)}
                className="rounded-lg px-3 py-3 text-left text-base font-medium text-slate-200 hover:bg-white/5"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/ferramenta"
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-3 text-left text-base font-medium text-violet-300 hover:bg-white/5 no-underline"
            >
              Testar ferramenta
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
